import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { Row, Table } from "antd";
import { toJS, runInAction, action } from "mobx";
import TableText from "../../table/TableText";
import { calculation } from "@/method";

const totalIndex = [];

@inject("store")
@observer
class App extends Component {
  @action
  onChange = (name, value, i) => {
    let data = toJS(this.props.store.kpifollow.food);
    data[i][name] = value;
    for (let i = 0; i < data.length; i++) {
      data[i].cop = calculation(data[i].act, data[i].bud, 4);
    }
    this.props.store.kpifollow.food = data;
  };

  render() {
    const { data, loading, food } = this.props.store.kpifollow;
    const columns = [
      {
        title: "餐厅",
        align: "center",
        children: [
          {
            title: "",
            dataIndex: `name`,
            key: `name`,
            width: 150,
            align: "center",
            render: (text, record, index) => {
              const props = {
                text,
                index,
                type: "text",
                name: `name`,
                onChange: this.onChange,
                totalIndex,
              };
              if (index == 0)
                return {
                  props: {
                    rowSpan: 6,
                  },
                  children: <TableText data={props} />,
                };
              return {
                props: {
                  rowSpan: 0,
                },
              };
            },
          },
          {
            title: "项目",
            dataIndex: `project`,
            key: `project`,
            width: 150,
            align: "center",
            render: (text, record, index) => {
              const props = {
                text,
                index,
                type: "text",
                name: `project`,
                onChange: this.onChange,
                totalIndex,
              };
              return <TableText data={props} />;
            },
          },
        ],
      },
      {
        title: "MTD",
        align: "center",
        children: [
          {
            title: "ACT实际",
            dataIndex: `act`,
            key: `act`,
            width: 150,
            align: "center",
            render: (text, record, index) => {
              const props = {
                text,
                index,
                type: "inputNumber",
                name: `act`,
                onChange: this.onChange,
                totalIndex,
              };
              return <TableText data={props} />;
            },
          },
          {
            title: "BUD预算",
            dataIndex: `bud`,
            key: `bud`,
            width: 150,
            align: "center",
            render: (text, record, index) => {
              const props = {
                text,
                index,
                type: "inputNumber",
                name: `bud`,
                onChange: this.onChange,
                totalIndex,
              };
              return <TableText data={props} />;
            },
          },
          {
            title: "完成率(%)",
            dataIndex: `cop`,
            key: `cop`,
            width: 150,
            align: "center",
            render: (text, record, index) => {
              const props = {
                text,
                index,
                type: "percent",
                name: `cop`,
                onChange: this.onChange,
                totalIndex,
              };
              return <TableText data={props} />;
            },
          },
        ],
      },
      {
        title: "本周A+F(周一-周日)",
        align: "center",
        children: [
          {
            title: "实际+预计收入",
            dataIndex: `af`,
            key: `af`,
            width: 150,
            align: "center",
            render: (text, record, index) => {
              const props = {
                text,
                index,
                type: "inputNumber",
                name: `af`,
                onChange: this.onChange,
                totalIndex,
              };
              return <TableText data={props} />;
            },
          },
        ],
      },
      {
        title: "下周预测(周一-周日)",
        align: "center",
        children: [
          {
            title: "预测收入",
            dataIndex: `f`,
            key: `f`,
            width: 150,
            align: "center",
            render: (text, record, index) => {
              const props = {
                text,
                index,
                type: "inputNumber",
                name: `f`,
                onChange: this.onChange,
                totalIndex,
              };
              return <TableText data={props} />;
            },
          },
        ],
      },
    ];

    return (
      <div className="" style={{ marginTop: 50 }}>
        <div>
          <Row className="secondary_title">酒店餐饮</Row>
          <Table
            columns={columns}
            dataSource={toJS(food)}
            size="middle"
            bordered
            pagination={false}
            className="content"
            rowKey={"r.project"}
          />
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/kpifollow/Table2.js